<div class="container">
  <mic-breadcrumb id="application-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('applicationText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h1 class="mt-4 mb-4">{{ translationService.translate('applicationText') }}</h1>
  <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="isLoading">
    <div style="display: flex; justify-content: flex-end; margin-bottom: 8px">
      <button mat-flat-button color="primary" (click)="openExportModal()">
        <mat-icon>download</mat-icon>
        {{ translationService.translate('exportButtonText') }}
      </button>
    </div>

    <div id="product-application-table" class="cam-table table-container">
      <mic-table class="table-stripped" [config]="tableConfig" [dataSource]="refInfos">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>
      </mic-table>
    </div>
  </mic-spinner-overlay>
</div>
